import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Swal from "sweetalert2";
import { createAccount } from "../../../API/Candidates/CreateCandidateAccount";
import { signin } from "../../../API/Login/login";
import { CompanyContext } from "../../../Store/CompanyContext";
import SelectedAreas from "./SelectedAreas";
import { getCountry } from "../../../API/Lists/country";
import { EmployerContext } from "../../../Store/EmployerContext";
import { useIntl } from "react-intl";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const FormCandidate = () => {
  const { actions } = useContext(CompanyContext);
  const { actions: employerActions, store: employerStore } = useContext(EmployerContext);
  const [value, setValue] = useState(employerStore.language === "ES" ? "ES" : "PT-BR");
  const history = useHistory();
  const language = employerStore.language === "ES" ? "ES" : "PT-BR";

  const objEmpty = {
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
    areas: [],
    country_id: "",
  };

  const handleSelect = (e) => {
    setValue(e);
  };
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [dataToSend, setDataToSend] = useState(objEmpty);
  const [countryList, setCountryList] = useState([]);

  const onChangeAreas = (e) => {
    const valorDataId = e.target.options[e.target.selectedIndex].getAttribute("data-areaid");
    // Verificar si el valorDataId ya existe en selectedAreas
    const isDuplicate = selectedAreas.some((area) => area.valorDataId === valorDataId);

    if (!isDuplicate) {
      const newArea = { valorDataId, area: e.target.value };
      setSelectedAreas([...selectedAreas, newArea]);
    }
  };

  useEffect(() => {}, [selectedAreas]);

  const onRemoveArea = (area) => {
    const nuevoSelectedAreas = selectedAreas.filter((objeto) => objeto.area !== area);
    setSelectedAreas(nuevoSelectedAreas);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDataToSend((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    const valorDataIds = selectedAreas.map((area) => parseInt(area.valorDataId));
    setDataToSend((prevState) => ({
      ...prevState,
      areas: valorDataIds,
    }));
  }, [selectedAreas]);

  useEffect(() => {
    const fetchCountry = async () => {
      setCountryList(await getCountry());
    };

    fetchCountry();
    return () => {
      setCountryList([]);
    };
  }, []);

  const changeLanguage = (country) => {
    const language = country == 4 ? "PT-BR" : "ES";
    employerActions.setLanguage(language);
  };

  const handleSend = async () => {
    if (
      dataToSend.name !== "" &&
      dataToSend.country_id !== "" &&
      dataToSend.email !== "" &&
      dataToSend.password !== "" &&
      dataToSend.areas.length > 0 &&
      dataToSend.password === dataToSend.confirmPassword
    ) {
      const response = await createAccount(dataToSend);
      console.log(response.case === 3);

      if (response.case === 3) {
        Swal.fire({
          title: "Ops!!!",
          text: language === "PT-BR" ? "O usuário já existe!" : "El usuario ya existe!",
          icon: "error",
        }).then(async () => {
          history.push("/");
        });
      } else {
        const account = {
          email: dataToSend.email,
          password: dataToSend.password,
          roleId: 3,
        };

        Swal.fire({
          title: language === "PT-BR" ? "Bem Vindo ao MyDNA" : "Bienvenido a MyDNA",
          text: language === "PT-BR" ? "Viva a experiência de candidado" : "Vive la experiencia del candidato",
          icon: "success",
        }).then(async () => {
          const login = await signin(account);
          changeLanguage(dataToSend.country_id);
          localStorage.setItem("token", login.token);
          localStorage.setItem("user", JSON.stringify(login.response));
          localStorage.setItem("candidateId", JSON.stringify(login.response.candidateId));

          const bringElementsForToken = dataToSend.email + ":" + dataToSend.password;
          const hash = window.btoa(bringElementsForToken);
          localStorage.setItem("hash", hash);

          actions.setLogin(login.response);
          history.push("/candidate");
        });
      }
    } else {
      Swal.fire({
        text: language === "PT-BR" ? "Para completar o registro, por favor, preencha todos os campos" : "Para completar el registro, por favor, rellene todos los campos",
      });
    }
  };

  return (
    <>
      <div className="d-flex align-items-center justify-content-center">
        <div className="col-6 d-flex justify-content-center align-items-center">
          <img src={`${process.env.REACT_APP_API_STORAGE}banner-register-candidate.png`} alt="Imagem" style={{ maxWidth: "100%", maxHeight: "100%" }} />
        </div>

        <Form className="col-6 ms-5">
          <Form.Group className="mb-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center ">
                <img
                  style={{ maxWidth: "230px" }}
                  className="companyLogo img-fluid mb-2"
                  src={`https://assets.mydna.company/logo-black-MyDNA.png`}
                  alt={language === "PT-BR" ? "Logotipo da empresa" : "Logotipo de la empresa"}
                />
                <span className="ms-2">| {language === "PT-BR" ? "Portal de Carreira " : "Portal de Carrera"}</span>
              </div>
              <div className="">
                <DropdownButton className="custom-dropdown-login rounded-pill" size="sm" title={value} onSelect={handleSelect}>
                  <Dropdown.Item eventKey="ES" onClick={() => employerActions.setLanguage("ES")}>
                    ES
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="PT" onClick={() => employerActions.setLanguage("PT-BR")}>
                    PT
                  </Dropdown.Item>
                </DropdownButton>
              </div>
            </div>
            <h5>{language === "PT-BR" ? "Criar sua conta" : "Crea tu cuenta"} </h5>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>{language === "PT-BR" ? "Nome" : "Nombre"}</Form.Label>
            <Form.Control
              className="px-2 py-3"
              type="Name"
              placeholder={language === "PT-BR" ? "Qual seu nome" : "¿Cuál es tu nombre?"}
              name={"name"}
              onChange={(e) => {
                handleChange(e);
              }}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>{language === "PT-BR" ? "Email" : "Correo"}</Form.Label>
            <Form.Control
              className="px-2 py-3"
              type="email"
              placeholder={language === "PT-BR" ? "Seu email" : "Tu dirección de correo electrónico"}
              name={"email"}
              onChange={(e) => {
                handleChange(e);
              }}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{language === "PT-BR" ? "Senha" : "Contraseña"}</Form.Label>
            <Form.Control
              className="px-2 py-3"
              type="password"
              placeholder={language === "PT-BR" ? "Use uma senha segura" : "Usa una contraseña segura"}
              name={"password"}
              onChange={(e) => {
                handleChange(e);
              }}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>{language === "PT-BR" ? "Confirme sua senha" : "Confirma tu contraseña"}</Form.Label>
            <Form.Control
              className="px-2 py-3"
              type="password"
              placeholder={language === "PT-BR" ? "Confirmar senha" : "Vuelve a escribir tu contraseña"}
              name={"confirmPassword"}
              onChange={(e) => {
                handleChange(e);
              }}
            />
            {dataToSend.password !== dataToSend.confirmPassword && (
              <>
                <Form.Text style={{ color: "red" }}>{language === "PT-BR" ? "As senhas não coincidem" : "Contraseñas no coinciden"}</Form.Text>
              </>
            )}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>País</Form.Label>

            <Form.Select
              name="country_id"
              defaultValue=""
              onChange={(e) => {
                handleChange(e);
              }}
            >
              <option disabled value="">
                {language === "PT-BR" ? "País" : "País"}
              </option>
              {countryList.map((country) => (
                <option value={country.id} key={country.id}>
                  {country.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group>
            <Form.Label>{language === "PT-BR" ? "Áreas de interesse" : "Áreas de interés"}</Form.Label>
            <div>
              <SelectedAreas language={language} selectedAreas={selectedAreas} onChangeAreas={onChangeAreas} handleChange={handleChange} onRemoveArea={onRemoveArea} />
            </div>
          </Form.Group>
          <Form.Group>
            <Button
              className="mt-1 w-100 rounded"
              variant="primary"
              onClick={() => {
                handleSend();
              }}
            >
              {language === "PT-BR" ? "Criar sua conta" : "Crear cuenta"}
            </Button>
          </Form.Group>
        </Form>
      </div>
    </>
  );
};

export default FormCandidate;
